"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { IngestThoughtsRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { ingestThoughts } from "../api/ingestThoughts";
import { thoughtKeys } from "../queries/keys";

export default function useIngestThoughtsMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: IngestThoughtsRequest) =>
      ingestThoughts(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: thoughtKeys.all });
    },
  });
}
